<template>
  <div>
    <div class="mb-3 body-1 font-weight-medium">{{title}}</div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'FieldWithTitle',
    props: ['title']
  }
</script>

<style scoped>

</style>
